export default "## Examples\n\n这里放一些 antdv@2x 的组件用例\n";